module.exports = __webpack_public_path__ + "static/media/record-vinyl.f593435c.svg";